import masterListActionTypes from './action-types';

export const fetchServicesCatalog = payload => ({
  type: masterListActionTypes.FETCH_SERVICES,
  payload,
});

export const fetchServicesCatalogSuccess = payload => ({
  type: masterListActionTypes.FETCH_SERVICES_SUCCESS,
  payload,
});

export const fetchServicesCatalogFail = payload => ({
  type: masterListActionTypes.FETCH_SERVICES_FAIL,
  payload,
});

export const fetchAddServiceSubmission = payload => ({
  type: masterListActionTypes.FETCH_ADD_SERVICE_SUBMISSION,
  payload,
});

export const fetchAddServiceSubmissionSuccess = payload => ({
  type: masterListActionTypes.FETCH_ADD_SERVICE_SUBMISSION_SUCCESS,
  payload,
});

export const fetchAddServiceSubmissionFail = payload => ({
  type: masterListActionTypes.FETCH_ADD_SERVICE_SUBMISSION_FAIL,
  payload,
});
